import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SubmissionSummaryService } from '../../data-access/services/submission-summary.service'; // updated import

@Component({
  selector: 'app-companyinfo-summary',
  templateUrl: './companyinfo-summary.component.html',
  styleUrls: ['./companyinfo-summary.component.scss'],
  standalone: false,
})
export class CompanyinfoSummaryComponent implements OnInit {
  @Input() currentYear!: number;
  @Input() prfNumber!: string;
  @Input() groupCode!: string;
  companyInfo: any;
  companyInfoLoaded: boolean = false;
  constructor(
    private readonly submissionSummaryService: SubmissionSummaryService, // updated injection
    private readonly router: Router
  ) {}
  ngOnInit(): void {
    this.LoadCompanyInfo();
  }
  LoadCompanyInfo() {
    this.submissionSummaryService
      .loadCompanyInfo(this.currentYear, this.prfNumber, this.groupCode)
      .subscribe({
        next: (companyData) => {
          if (companyData) {
            this.companyInfo = companyData;
            console.log(this.companyInfo);
            this.companyInfoLoaded = true;
          }
        },
        error: (error) => {
          this.companyInfoLoaded = false;
          this.router.navigate(['/apifailure']);
        },
      });
  }
}
